<template>
  <div class="search-layout">

    <MarketHeader
      :selectedHeader="useHeader"
    />
    <main class="search-layout__content">
      <router-view></router-view>
    </main>

    <MarketFooter v-if="useFooter" />

		<BackGround/>

		<BackToTop/>

  </div>
</template>

<script lang="ts">

import { defineComponent } from "vue";

import MarketHeader from '@/components/header/header.vue';
import MarketFooter from '@/components/footer/footer.vue';
import BackToTop from '@/components/design/backToTop.vue';
import BackGround from '@/components/design/background.vue';

export default defineComponent({
  name: "SearchLayaout",
  components: {
    MarketHeader,
    MarketFooter,
		BackToTop,
		BackGround
  },
  setup() {

    return {
      useHeader: "searchHeader",
      useFooter: true,
    };
  },
});

</script>

<style scoped>
	@import '../assets/css/helper.css';
	@import '../assets/css/owl.carousel.min.css';
	@import '../assets/css/responsive.css';
	@import '../assets/css/style.css';

.search-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.search-layout__content {
  flex: 1 0 auto;
}
</style>
